<template>
  <v-card
    class="card py-12"
    :min-height="settings.bg && settings.bg.height ? settings.bg.height : '300'"
    elevation="0"
    tile
    :color="MIXIN_getBgInfo(settings, 'color')"
    :img="MIXIN_getBgInfo(settings, 'image')"
  >
    <section class="d-flex flex-column flex align-center justify-center">
      <div class="pb-8">
        <title-component
          v-if="settings.title && settings.title.content"
          :settings="{...settingsTitle, idLayout: settings.idLayout}"
          :id="id"
        />
      </div>

      <section>
        <div v-for="(item, i) in groups" :key="i">
          <div>
            <div class="text-center py-6">
              <b
                :style="
                  `
                  text-align: center;
                  font-family: ${settings.observation.font || ''} !important; 
                  font-size: ${settings.observation['font-size'] || ''} !important; 
                  color: ${settings.observation.color} !important; 
                  line-height: ${settings.observation['font-size']} !important; 
                  font-weight: ${settings.observation.weight} !important;
                  font-style: ${settings.observation['font-style']} !important;
                  `
                "
              >
                {{ item.nome }}
              </b>
            </div>

            <v-container style="max-width: 1340px">
              <v-row class="mx-12" justify="center" align="center">
                <v-col
                  v-for="(sponsor, index) in item.patrocinadores"
                  :key="index"
                  :cols="
                    $vuetify.breakpoint.mdAndUp
                      ? item.column
                        ? item.column
                        : '2'
                      : item.sponsors && item.sponsors.length === 1
                      ? '10'
                      : '6'
                  "
                  align="center"
                  :class="$vuetify.breakpoint.mdAndUp ? 'pa-6' : ''"
                >
                  <v-img
                    height="'50px'"
                    width="100"
                    eager
                    contain
                    :src="sponsor.url_logo"
                  ></v-img>

                  <v-row no-gutters> </v-row>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </div>
      </section>
    </section>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import TitleComponent from "../title/TitleComponent.vue";
import { GetLayoutSectionMixin } from "../../mixins/GetLayoutSection"

export default {
  mixins: [GetLayoutSectionMixin],  
  components: { TitleComponent },
  props: {
    id: {type: String},
    settings: {
      type: Object,
    },
  },

  data() {
    return {
      settingsTitle: null,
      sizeMdUp: {
        P: "35",
        M: "55",
        G: "85",
      },
      sizeMdDown: {
        P: "55",
        M: "85",
        G: "120",
      },
      hover: false,
    };
  },

  computed: {
    ...mapGetters(["sponsors"]),
    groups() {
      let mappedSponsors = [];

      if (this.sponsors)
        mappedSponsors = this.sponsors.map((s) => {
          return {
            ...s,
            settings: {
              title: {
                color: "",
                content: s.nome,
                font: "",
                "font-size": "22px",
              },
              subtitle: "",
              "background-color": "transparent",
            },
          };
        });

      return mappedSponsors;
    },
  },

  created() {
    this.settingsTitle = {
      title: this.settings.title,
      subtitle: this.settings.subtitle,
      "background-color": "transparent",
    };
  },
};
</script>

<style scoped>
  .div-style {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .card {
    display: flex;
    flex-direction: column;
  }
</style>
